import {makeStyles} from "@material-ui/core";

export default function SectionCss() {
    return makeStyles(theme => ({
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing(2),
            color: theme.palette.text.secondary,
        },
        container: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: '100%',
        },
        boxForm: {
            padding: '30px'
        },
        multilineColor: {
            color: 'rgb(118, 118, 118) !important',
            borderBottomColor: '#159B78 !important',
            "&::after": {
                borderBottomColor: '#159B78 !important',
            }
        },
        buttonAction: {
            marginTop: 30,
            width: '100%'
        },
        buttonCancelar: {
            color: 'rgb(118, 118, 118) !important',
            marginRight: '10px',
        },
        buttonAdicionar: {
        },
        cardFile: {
            marginTop: 20,
            marginBottom: 20,
            width: '100%'
        },
        title: {
        }
    }));
}